export default __webpack_public_path__ + "static/media/new-report.313819b4.svg";